import {pageCleaningFunctions} from "../general/barba";
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {debounce} from "lodash";

gsap.registerPlugin(ScrollTrigger);
export const debouncedScrollTriggerRefresh = debounce(() => {
  ScrollTrigger.refresh(true)
}, 1000)
//
// export function getHeightOfViewPort() {
// // Then we set the value in the --vh custom property to the root of the document
//   const setHeight = debounce(() => {
//     document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
//     debouncedScrollTriggerRefresh()
//   }, 500)
//
//   setHeight();
//   window.addEventListener('resize', setHeight);
//   pageCleaningFunctions.push(() => window.removeEventListener('resize', setHeight))
// }
export function getHeightOfViewPort() {
// Then we set the value in the --vh custom property to the root of the document
  let lastHeight = 0;
  const intervalKey = setInterval(() => {
    const newHeight = window.innerHeight;
    if (newHeight !== lastHeight) {
      lastHeight = newHeight;
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
      debouncedScrollTriggerRefresh();
    }
  }, 1000)
  pageCleaningFunctions.push(() => clearInterval(intervalKey))
}
